import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_39kn6t66bv: FaireBrandEntity = {
  token: "b_39kn6t66bv",
  type: "brand",
  name: "River Ridge Soaps",
  avatarUrl:
    "https://cdn.faire.com/fastly/7645a317a2a347d329ef5f2a47de13f928fc44f34fb46a524d3fb0361511857a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d591ca09fcc215a57573ef63ed94ec5e0855e70a53f9f798063f82aa3e27bb8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7645a317a2a347d329ef5f2a47de13f928fc44f34fb46a524d3fb0361511857a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d591ca09fcc215a57573ef63ed94ec5e0855e70a53f9f798063f82aa3e27bb8.jpeg",
  location: "Maple Valley, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 11,
  isInsider: true,
  description:
    "We are passionate about high-quality soaps that are both visually beautiful and moisturizing.   Cocoa Butter, Shea Butter, and Olive Oil in every bar ensure that River Ridge soaps are the highest quality handcrafted soaps you can purchase. River Ridge Soap is a recipe developed over 15 years to ensure each bar moisturizes, provides natural and non-perfumy aromatherapy with each shower, and lasts an extended time.   We are very picky about our scents.  We went through 5 lilac fragrances to find one that smelled just like the real flower.  All our florals smell like they are picked from a garden.  We offer all natural colorants and essential oils for those that want 100% natural products.\n\nRiver Ridge soaps are crafted by soap artist of 25+ years, Diane Holt, with responsively harvested vegan oils, fragrances, and essential oils.  In a studio at the base of Mt. Rainer she hand pours, cleans, and designs each soap. Every soap is formulated in small batches (18 soaps) and combines artistic designs with one amazing bar of soap.  Try it in your shower for free by contacting Diane for a free bar!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:56.923Z",
    importedBy: "entity-db-cli",
  },
};
